import { OPS_ABILITY } from "./ops";
import { BRAND_ABILITY } from "./brand";
import { PUBLISHER_ABILITY } from "./publisher";

// Looked up by role so each workspace only ever gets its own abilities.
export const ROLE_ABILITY = {
    ops      : OPS_ABILITY,
    brand    : BRAND_ABILITY,
    publisher: PUBLISHER_ABILITY
};
